import React, { Component } from 'react';
import { Link as AnchorLink } from 'react-scroll';

class Landing extends Component {
    render() {
        return ( 
            <section className="HomeLanding hero is-fullheight">
                <div className="HomeLandingBg">
                    <div className="HomeLandingBgImage"></div>
                    <video className="HomeLandingBgVideo" autoPlay="autoplay" muted="muted" loop="loop">
                        <source src="/Videos/HomeLanding1280.mp4" type="video/mp4" />
                    </video>
                </div>
                <div className="HomeLandingText hero-body">
                    <div className="container has-text-centered">
                        <h2 className="HomeLandingTitle title has-text-white is-spaced">
                            <span className="FirstPhrase">Publish and Utilize</span>
                            <span className="SecondPhrase">Your GIS Data, Maps</span>
                        </h2>
                        <p className="HomeLandingSubtitle subtitle is-size-5 is-size-6-mobile has-text-white-ter">แพลตฟอร์มสำหรับสร้าง จัดเก็บ และ ส่งต่อข้อมูลแผนที่เพื่อนำไปใช้ประโยชน์</p>
                        <AnchorLink 
                            className="HomeLandingAction button is-primary is-rounded" 
                            to="AnchorPoint" 
                            spy={true} 
                            smooth={true} 
                            offset={2} 
                            duration={500} >
                            Use Cases
                        </AnchorLink>
                    </div>
                </div>
            </section>
        )
    }
}

export default Landing;


// WEBPACK FOOTER //
// ./src/PageHome/_Landing.js